import { Styles, StylesGroup } from '@core/interfaces/styles/styles.interface';

export const mergeStyles = (styles: Styles, group?: string): StylesGroup => {
  const innerWidth = window.innerWidth;
  let groups = ['basic', 'hover', 'active'];
  if (group) {
    groups = [group];
  }
  const style = {};

  groups.forEach((group) => {
    style[group] = {...styles[group], ...styles.all?.[group]};
    if (innerWidth > 991) {
      style[group] = styles.all?.[group] || {};
    } else if (innerWidth <= 991 && innerWidth >= 480) {
      style[group] = {
        ...(styles.all?.[group] || {}),
        ...(styles.maxWidth991Px?.[group] || {}),
      };
    } else if (innerWidth <= 479) {
      style[group] = {
        ...(styles.all?.[group] || {}),
        ...(styles.maxWidth991Px?.[group] || {}),
        ...(styles.maxWidth479Px?.[group] || {}),
      };
    }
  });

  return style;
};
